import React from 'react';
import { NavLink, Link } from 'react-router-dom';
import { reactLocalStorage } from 'reactjs-localstorage';
import Dropdown from 'react-bootstrap/Dropdown';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import Form from 'react-bootstrap/Form';
import FormControl from 'react-bootstrap/FormControl';
import Modal from 'react-bootstrap/Modal';
import { FaCalendarAlt, FaQuestionCircle, FaPhoneAlt, FaWhatsapp, FaClock, FaCog } from 'react-icons/fa';
import { MdOutlineSupportAgent } from 'react-icons/md';
import Const from '../../util/Constants';
import withRouter from '../../util/WithRouter';
import Display from '../../util/Display';
import BellMenu from './BellMenu';
import MainSearchAPI from '../../api/MainSearchAPI';
import CompanyAPI from '../../api/CompanyAPI';
import Util from '../../util/Util';
import './Menu.css';
import { PiDotsNineBold } from "react-icons/pi";
import { FaBuilding, FaUsers, FaMoneyCheckAlt, FaBook, FaBoxes, FaHeadset,
         FaGlobe, FaMobileAlt, FaChartLine, FaLaptopCode, FaBrain } from "react-icons/fa";
import { SiGooglemarketingplatform } from "react-icons/si";
import { FaYoutube } from "react-icons/fa";


class Menu extends React.Component {
  
  constructor(props) {
    super(props);
    this.state = {main_search: '',logo: '',searches: { leads: [], contacts: [], properties: [], projects: [] },showHelpModal: false, showProductsModal: false};
    this.models = reactLocalStorage.getObject(Const.Model);
    this.user = reactLocalStorage.getObject(Const.LoggedInUser);
    this.modulePermission = this.models.module_permission?.modules;
    this.user = reactLocalStorage.getObject(Const.LoggedInUser);
    this.LeadView = Util.isAllow(this.models.lead.permission, Const.PermView);
    this.LeadRestrict = Util.isAllow(this.models.lead.permission, Const.PermRestricAcc);
    this.LeadSearchRestrict = Util.isAllow(this.models.lead.permission, Const.SearchOnMobile);
    this.ContactView = Util.isAllow(this.models.contact.permission, Const.PermView);
    this.ContactRestrict = Util.isAllow(this.models.contact.permission, Const.PermRestricAcc);
    this.ContactSearchRestrict = Util.isAllow(this.models.contact.permission, Const.SearchOnMobile);
    this.PropertyView = Util.isAllow(this.models.property.permission, Const.PermView);
    this.PropertyRestrict = Util.isAllow(this.models.property.permission, Const.PermRestricAcc);
    this.ProjectView = Util.isAllow(this.models.project.permission, Const.PermView);
    this.ProjectRestrict = Util.isAllow(this.models.project.permission, Const.PermRestricAcc);

    this.LiveLocationTrackingPermView = this.modulePermission?.filter(perm =>  perm?.key === Const.LiveLocationTrackingModule)?.[0]?.value ?? 0;
  }

  componentDidMount() {
    CompanyAPI.getLogo(this.onLogo);
  }

  onLogo = (res) => {
    this.setState({ logo: res.logo });
  };

  toggleHelpModal = (flag) => {
    this.setState({ showHelpModal: flag });
  };

  toggleProductsModal = (flag) => {
    this.setState({ showProductsModal: flag });
  };

  onValueChange = (main_search) => {
    const SearchBody = {};
    const field = 'responsible_person';
    const type = 'multiselect~user';
    const condition = 'in';
    const value = `${Const.Opt}${[this.user.user_id, ...this.user.child].join('~')}${Const.Opt}`;

    if (!this.LeadView) {
      SearchBody.lead = [{ field, type, condition, value: `${Const.Opt}0${Const.Opt}` }];
    } else if (this.LeadRestrict) {
      if (this.LeadSearchRestrict && (/^[0-9]{8,}$/.test(main_search) ||
        /^[a-zA-Z0-9._:$!%-]+@+[a-zA-Z0-9-_]+([.]{1}[a-zA-Z0-9-_]+)+$/.test(main_search))) {
        SearchBody.lead = [];
      } else {
        SearchBody.lead = [{ field, type, condition, value }];
      }
    }

    if (!this.ContactView) {
      SearchBody.contact = [{ field, type, condition, value: `${Const.Opt}0${Const.Opt}` }];
    } else if (this.ContactRestrict) {
      if (this.ContactSearchRestrict && (/^[0-9]{8,}$/.test(main_search) ||
        /^[a-zA-Z0-9._:$!%-]+@+[a-zA-Z0-9-_]+([.]{1}[a-zA-Z0-9-_]+)+$/.test(main_search))) {
        SearchBody.contact = [];
      } else {
        SearchBody.contact = [{ field, type, condition, value }];
      }
    }

    if (!this.PropertyView) {
      SearchBody.property = [{ field, type, condition, value: `${Const.Opt}0${Const.Opt}` }];
    } else if (this.PropertyRestrict) {
      SearchBody.property = [{ field, type, condition, value }];
    }

    if (!this.ProjectView) {
      SearchBody.project = [{ field, type, condition, value: `${Const.Opt}0${Const.Opt}` }];
    } else if (this.ProjectRestrict) {
      SearchBody.project = [{ field, type, condition, value }];
    }

    if (main_search.length > 2) {
      this.setState({ main_search });
      if (main_search.length < 30) {
        MainSearchAPI.list(main_search, SearchBody, this.onReceived);
      }
    } else {
      this.setState({ main_search, searches: { leads: [], contacts: [], properties: [], projects: [] } });
    }
  };

  onReceived = (searches) => {
    this.setState({ searches });
  };

  onSearchClick = (url) => {
    this.setState({ main_search: '', searches: { leads: [], contacts: [], properties: [], projects: [] } });
    this.props.navigate(url);
  };

  render() {
    const { main_search, searches, showHelpModal } = this.state;
    const models = this.models;

    const leads = searches.leads?.map((lead, i) => (
      <ul key={`search_lead_${i}`}>
        <li onClick={() => this.onSearchClick(`/lead/preview/${lead.id}`)}>
          {Display.ModelName(lead)}
        </li>
      </ul>
    ));

    const contacts = searches.contacts?.map((contact, i) => (
      <ul key={`search_contact_${i}`}>
        <li onClick={() => this.onSearchClick(`/contact/preview/${contact.id}`)}>
          {Display.ModelName(contact)}
        </li>
      </ul>
    ));

    const properties = searches.properties?.map((property, i) => (
      <ul key={`search_property_${i}`}>
        <li onClick={() => this.onSearchClick(`/property/preview/${property.id}`)}>
          {`${property.id} - ${property.name}`}
        </li>
      </ul>
    ));

    const projects = searches.projects?.map((project, i) => (
      <ul key={`search_project_${i}`}>
        <li onClick={() => this.onSearchClick(`/project/preview/${project.id}`)}>
          {`${project.id} - ${project.project_name}`}
        </li>
      </ul>
    ));

    const leadCount = searches.leads?.length || 0;
    const contactCount = searches.contacts?.length || 0;

    return (
      <div className="menusec">
        <Navbar expand="lg" className="shadow-sm px-3 py-2 compact-navbar">
          <Navbar.Collapse id="main-navbar" className="justify-content-between">
   
            <Nav className="nav-scroll">

              {/* Logo and Label */}
              <div className="d-flex align-items-center me-3 px-2 py-1 rounded" style={{ backgroundColor: '#fff' }}>
                <img src="/images/console.png" alt="CRM" style={{ width: '25px', height: '20px' }} />
              </div>

              <NavLink to="/dashboard">Dashboard</NavLink>
              { Util.isAllow(models.lead.permission, Const.PermView)
                ?<NavLink to="/lead">{models.lead.model_name}</NavLink>
                : null
              }
              { Util.isAllow(models.cold_data.permission, Const.PermView) 
                ? <NavLink to="/cold-data">Cold Data</NavLink>
                : null
              }
              { Util.isAllow(models.contact.permission, Const.PermView) 
                ? <NavLink to="/contact">{models.contact.model_name}</NavLink>
                : null
              }
              { Util.isAllow(models.call.permission, Const.PermView) 
                ? <NavLink to="/call">{models.call.model_name}</NavLink>
                : null
              }
              { Util.isAllow(models.meeting.permission, Const.PermView) 
                ? <NavLink to="/meeting">{models.meeting.model_name}</NavLink>
                : null
              }
              { Util.isAllow(models.property.permission, Const.PermView) 
               ? <NavLink to="/property">{models.property.model_name}</NavLink>
               : null
              }
              { Util.isAllow(models.project.permission, Const.PermView) 
                ? <NavLink to="/project">{models.project.model_name}</NavLink>
                : null
              }
              { Util.isAllow(models.sales_order.permission, Const.PermView) 
                ? <NavLink to="/sales-order">{models.sales_order.model_name}</NavLink>
                : null
              }
              { Util.isAllow(models.attendance.permission, Const.PermView) 
                ? <NavLink to="/attendance">{models.attendance.model_name}</NavLink>
                : null
              }
              <NavLink to="/report">Reports</NavLink>
              {(Util.isAllow(models.lead_search?.permission || 0, Const.PermLeadSearchRestrictedView) ||
                Util.isAllow(models.installment.permission, Const.PermView) ||
                Util.isAllow(models.customer.permission, Const.PermView))
                ? <Dropdown>
                  <Dropdown.Toggle as={Nav.Link}>More</Dropdown.Toggle>
                  <Dropdown.Menu>
                    {Util.isAllow(models.lead_search?.permission || 0, Const.PermLeadSearchRestrictedView) && (
                      <Dropdown.Item as={Link} to="/search">Check Lead</Dropdown.Item>
                    )}
                    {Util.isAllow(models.installment.permission, Const.PermView) && (
                      <Dropdown.Item as={Link} to="/installment">{models.installment.model_name}</Dropdown.Item>
                    )}
                    {Util.isAllow(models.customer.permission, Const.PermView) && (
                      <Dropdown.Item as={Link} to="/customer">{models.customer.model_name}</Dropdown.Item>
                    )}
                    {this.LiveLocationTrackingPermView ? (
                      <Dropdown.Item as={Link} to="/live-location-tracking">Live Location Tracking</Dropdown.Item>
                    ) : null}
                  </Dropdown.Menu>
                </Dropdown>
                : null
              }
            </Nav>
            <div className="d-flex align-items-center gap-2 right-side-nav">
              <div className="search-container position-relative">
                <Form>
                  <FormControl
                    type="text"
                    placeholder="Search Contact, Leads"
                    className="mr-sm-2"
                    onChange={(e) => this.onValueChange(e.target.value)}
                    value={main_search}
                    style={{height: '36px', width: '210px'}}
                  />
                </Form>
                {main_search.length > 0
                  ? <div className="leadsearchlist bg-white shadow rounded mt-1 p-2"
                      onMouseDown={(e) => e.preventDefault()} style={{width: '220px'}}>
                    { leadCount > 0 ? <div><strong>{this.models.lead.model_name}</strong>{leads}</div> : null }
                    { contactCount > 0 ? <div><strong>{this.models.contact.model_name}</strong>{contacts}</div> : null }
                    { properties?.length > 0 ? <div><strong>Properties</strong>{properties}</div> : null }
                    { projects?.length > 0 ? <div><strong>Projects</strong>{projects}</div> : null }
                    { (main_search && leadCount === 0 && contactCount === 0)
                      ? <div><small>No Result Found</small></div> : null
                    }
                  </div>
                  : null
                }
              </div>
              <Link to="/calendar" className="nav-icon-btn" title="Calendar"><FaCalendarAlt size={16} /></Link>
              <div className="nav-icon-btn" title="Notifications"><BellMenu size={16} /></div>
              { Util.isAllow(models.setting.permission, Const.PermView)
                ? <Link to="/setting" className="nav-icon-btn" title="Settings"><FaCog size={16} /></Link>
                : null
              }
              <div className="nav-icon-btn" title="Help" 
                onClick={() => this.toggleHelpModal(true)} style={{ cursor: "pointer" }}>
                <MdOutlineSupportAgent size={18} />
              </div>
              <div className="nav-icon-btn"
                  title="More Products"
                  style={{ cursor: "pointer" }}
                  onClick={() => this.toggleProductsModal(true)}>
                <PiDotsNineBold size={20} />
              </div>
            </div>
          </Navbar.Collapse>
        </Navbar>
   <Modal show={showHelpModal} onHide={() => this.toggleHelpModal(false)} centered backdrop="static" className="help-modal">
  <Modal.Header closeButton className="help-header text-white border-0">
    <Modal.Title><FaQuestionCircle className="me-2 mb-1" /> Need Help?</Modal.Title>
  </Modal.Header>
  <Modal.Body className="help-body">
    <div className="d-flex flex-column gap-4">
      <div className="help-row">
        <div className="help-icon bg-primary"><FaPhoneAlt /></div>
        <div>
          <h6 className="mb-1 fw-semibold">Support Number</h6>
          <a href="tel:+918104797220" className="help-link">+91-8104797220</a><br/>
          <a href="tel:+919082571634" className="help-link">+91-9082571634</a>
        </div>
      </div>
      <a href="https://wa.me/8104797220?text=I%20need%20help%20regarding%20CRM"
        target="_blank" rel="noopener noreferrer"
        className="help-row text-decoration-none text-dark">
        <div className="help-icon bg-success"><FaWhatsapp /></div>
        <div>
          <h6 className="mb-1 fw-semibold">WhatsApp</h6>
          <span className="help-link">Chat with us</span>
        </div>
      </a>

      {/* New YouTube Row */}
      <a href="https://www.youtube.com/@orggencrm3813"
        target="_blank" rel="noopener noreferrer"
        className="help-row text-decoration-none text-dark">
        <div className="help-icon bg-danger">
          <FaYoutube />
        </div>
        <div>
          <h6 className="mb-1 fw-semibold">YouTube</h6>
          <span className="help-link">Watch Videos</span>
        </div>
      </a>

      <div className="help-row">
        <div className="help-icon bg-warning text-dark"><FaClock /></div>
        <div>
          <h6 className="mb-1 fw-semibold">Working Hours</h6>
          <p className="mb-0 text-muted">Mon – Sat, 10:00 AM – 7:00 PM IST</p>
        </div>
      </div>
    </div>
  </Modal.Body>
</Modal>


{this.state.showProductsModal && (
  <>
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 9998,
      }}
      onClick={() => this.toggleProductsModal(false)}
    />
    <div
      style={{
        position: "absolute",
        top: "45px",
        right: "10px",
        width: "480px",
        maxHeight: "550px",
        backgroundColor: "#fff",
        borderRadius: "18px",
        boxShadow: "0px 10px 28px rgba(0,0,0,0.20)",
        padding: "20px 18px",
        zIndex: 9999,
        overflowY: "auto",
        transition: "0.3s ease"
      }}
    >
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <h5 style={{ margin: 0, fontWeight: "700", fontSize: "16px" }}>More Products</h5>
        <span
          style={{ cursor: "pointer", fontSize: "22px", fontWeight: "600" }}
          onClick={() => this.toggleProductsModal(false)}
        >
          ×
        </span>
      </div>

      {/* Products Section */}
      <h6 style={{ margin: "18px 0 10px 0", fontWeight: 600, fontSize: "14px" }}>Products</h6>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(3, 1fr)",
          gap: "14px"
        }}
      >
        {[
          { name: "Sales CRM", icon: <SiGooglemarketingplatform size={22} />, color: "#2563EB" },
          { name: "HRMS", icon: <FaUsers size={22} />, color: "#EC4899" },
          { name: "Payroll", icon: <FaMoneyCheckAlt size={22} />, color: "#059669" },
          { name: "Books", icon: <FaBook size={22} />, color: "#D97706" },
          { name: "Inventory", icon: <FaBoxes size={22} />, color: "#7C3AED" },
          { name: "Helpdesk", icon: <FaHeadset size={22} />, color: "#0EA5E9" }
        ].map((item, i) => (
          <div
            key={i}
            style={{
              background: "#F8FAFC",
              borderRadius: "16px",
              padding: "14px 10px",
              textAlign: "center",
              cursor: "pointer",
              fontSize: "13px",
              fontWeight: 500,
              border: "1px solid #e2e8f0",
              boxShadow: "0 3px 8px rgba(0,0,0,0.05)",
              transition: "0.25s"
            }}
            onClick={() => {
              if (item.name === "Sales CRM") window.open("https://sales.orggenteam.com/", "_blank");
              if (item.name === "HRMS") window.open("https://hrms.orggenteam.com/", "_blank");
              // if (item.name === "Payroll") window.open("https://yourdomain.com/payroll", "_blank");
              if (item.name === "Books") window.open("https://uat.d2k11atzdkxm4q.amplifyapp.com/1/dashboard", "_blank");
              if (item.name === "Inventory") window.open("https://inventory.orggenteam.com/", "_blank");
              if (item.name === "Helpdesk") window.open("https://helpdesk.orggenteam.com/dashboard", "_blank");
            }}

            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-4px)";
              e.currentTarget.style.boxShadow = "0 6px 14px rgba(0,0,0,0.12)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0px)";
              e.currentTarget.style.boxShadow = "0 3px 8px rgba(0,0,0,0.05)";
            }}
          >
            <div style={{ marginBottom: "6px", color: item.color }}>{item.icon}</div>
            {item.name}
          </div>
        ))}
      </div>

      {/* Services Section */}
      <h6 style={{ margin: "18px 0 10px 0", fontWeight: 600, fontSize: "14px" }}>Services</h6>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(3, 1fr)",
          gap: "14px"
        }}
      >
        {[
          { name: "Website Development", icon: <FaGlobe size={22} />, color: "#3B82F6" },
          { name: "Mobile App Development", icon: <FaMobileAlt size={22} />, color: "#10B981" },
          { name: "Digital Marketing", icon: <FaChartLine size={22} />, color: "#F59E0B" },
          { name: "Software Development", icon: <FaLaptopCode size={22} />, color: "#8B5CF6" },
          { name: "IT Consulting", icon: <FaBrain size={22} />, color: "#EF4444" }
        ].map((item, i) => (
          <div
            key={i}
            style={{
              background: "#F8FAFC",
              borderRadius: "16px",
              padding: "14px 10px",
              textAlign: "center",
              cursor: "pointer",
              fontSize: "13px",
              fontWeight: 500,
              border: "1px solid #e2e8f0",
              boxShadow: "0 3px 8px rgba(0,0,0,0.05)",
              transition: "0.25s"
            }}
          //  onClick={() => {
          //     if (item.name === "Website Development") window.open("https://yourdomain.com/website-development", "_blank");
          //     if (item.name === "Mobile App Development") window.open("https://yourdomain.com/mobile-app", "_blank");
          //     if (item.name === "Digital Marketing") window.open("https://yourdomain.com/digital-marketing", "_blank");
          //     if (item.name === "Software Development") window.open("https://yourdomain.com/software-development", "_blank");
          //     if (item.name === "IT Consulting") window.open("https://yourdomain.com/it-consultancy", "_blank");
          //   }}

            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-4px)";
              e.currentTarget.style.boxShadow = "0 6px 14px rgba(0,0,0,0.12)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0px)";
              e.currentTarget.style.boxShadow = "0 3px 8px rgba(0,0,0,0.05)";
            }}
          >
            <div style={{ marginBottom: "6px", color: item.color }}>{item.icon}</div>
            {item.name}
          </div>
        ))}
      </div>
    </div>
  </>
)}


      </div>
    );
  }
}
export default withRouter(Menu);
